import classNames from 'classnames';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { usePreferences } from '../../../hooks/usePreferences';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LEAD_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
} from '../PriceViewer';

const NOPSwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
  toggleShowParticipantNumber: () => void;
}> = ({ wrapAnalytics, toggleShowParticipantNumber }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    showParticipantsNumber,
    showShiftedParticipantsNumber,
    unit,
    nopColorStyleV2,
  } = usePreferences();

  return (
    <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
      <OverlayTrigger
        placement="auto-start"
        overlay={<Tooltip id="non-explain">{t('nop-explain')}</Tooltip>}
      >
        <span>
          <div
            className={classNames(
              DL_SWITCH_LEAD_CLASS_NAME,
              DL_SWITCH_CLASS_NAME,
              {
                checked:
                  showParticipantsNumber || showShiftedParticipantsNumber,
              }
            )}
            onClick={toggleShowParticipantNumber}
            style={{ color: nopColorStyleV2, fontWeight: 700 }}
          >
            {t('ccass-title')}
          </div>
          <div
            className={classNames(DL_SWITCH_CLASS_NAME, {
              checked: unit === 'd' && showParticipantsNumber,
              disabled: unit !== 'd',
            })}
            onClick={toggleShowParticipantNumber}
          >
            {t('nop1')}
          </div>
          <div
            className={classNames(DL_SWITCH_CLASS_NAME, {
              checked: unit === 'd' && showShiftedParticipantsNumber,
              disabled: unit !== 'd',
            })}
            onClick={wrapAnalytics('participant_no', () => {
              dispatch(
                preferenceActions.setPriceViewerShiftedParticipantsNumber(
                  !showShiftedParticipantsNumber
                )
              );
              if (!showShiftedParticipantsNumber) {
                dispatch(
                  preferenceActions.setPriceViewerParticipantsNumber(false)
                );
              }
            })}
          >
            {t('nop2')}
          </div>
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default NOPSwitch;
